import type {Component, Editor} from 'grapesjs';

export interface DropdownSelectorOption {
  textKey: string;
  value: string;
  icon?: string;
  /** Renders the icon on a mid-grey contrast surface so a near-white icon stays visible. */
  iconNeedsContrastBackground?: boolean;
}

export interface DropdownSelectorDescriptor {
  property: string;
  labelKey: string;
  defaultValue: string;
  options: readonly DropdownSelectorOption[];
  /** Fired after the base style write, for side-effects like auto/custom width routing. */
  onDropDownItemChange?: (component: Component, property: string, value: string, editor: Editor) => void;
}

export const WIDTH_MODE = {
  AUTO: 'auto',
  CUSTOM: 'custom',
} as const;

export const WIDTH_PROPERTY = 'width';
export const PERCENT_UNIT = '%';

export const DEFAULT_WIDTH_PERCENT = '100';
